module.exports = __webpack_public_path__ + "img/fapiao.4017547c.png";